export const roundToDecimal = (value: number, decimals = 2): number => {
  if (isNaN(value)) return 0;
  const factor = 10 ** decimals;
  return Math.round((value + Number.EPSILON) * factor) / factor;
};

export const normalizeNumber = (value: unknown, decimals = 2): number => {
  return roundToDecimal(Number(value || 0), decimals);
};

export const formatFixedDecimal = (value: number, decimals = 2): string => {
  return roundToDecimal(value, decimals).toFixed(decimals);
};

export const formatSignedDecimal = (value: number, decimals = 2): string => {
  const rounded = roundToDecimal(value, decimals);
  const formatted = formatFixedDecimal(rounded, decimals);
  return rounded > 0 ? `+${formatted}` : formatted;
};

export const roundMoney = (value: number): number => {
  if (isNaN(value)) return 0;
  return value % 1 >= 0.5 ? Math.ceil(value) : Math.floor(value);
};

export const formatMoney = (value: string): string => {
  const numericValue = value.replace(/[^\d.]/g, '');
  if (!numericValue) return '0';
  const [intPart, decimalPart] = numericValue.split('.');
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
};

export function formatNumber(number: number | string) {
  return number.toLocaleString('vi-VN');
}

export const formatPrice = (price: number): string => {
  return new Intl.NumberFormat('en-US').format(price);
};

export const formatCurrency = (amount: number): string => {
  return `${formatPrice(amount)}`;
};

export const formatMoneyVN = (value?: number | string | null) => {
  if (value === null || value === undefined || value === '') return '';

  const num = Number(value);

  return new Intl.NumberFormat('vi-VN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(num);
};

export const formatQuantityVN = (value?: number | string | null) => {
  if (value === null || value === undefined || value === '') return '';

  const num = Number(value);

  return new Intl.NumberFormat('vi-VN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  }).format(num);
};
